import { render, staticRenderFns } from "./FloorPlanItemRanking.vue?vue&type=template&id=0b47f2f3&scoped=true&"
import script from "./FloorPlanItemRanking.vue?vue&type=script&lang=js&"
export * from "./FloorPlanItemRanking.vue?vue&type=script&lang=js&"
import style0 from "./FloorPlanItemRanking.vue?vue&type=style&index=0&id=0b47f2f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47f2f3",
  null
  
)

/* custom blocks */
import block0 from "./FloorPlanItemRanking.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b47f2f3')) {
      api.createRecord('0b47f2f3', component.options)
    } else {
      api.reload('0b47f2f3', component.options)
    }
    module.hot.accept("./FloorPlanItemRanking.vue?vue&type=template&id=0b47f2f3&scoped=true&", function () {
      api.rerender('0b47f2f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/FloorPlanItemRanking.vue"
export default component.exports